/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const PowerOff = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M14.4 3.7c2 1.4 3.3 3.8 3.3 6.4 0 4.3-3.5 7.8-7.8 7.9C5.5 18 2 14.5 2 10.1c0-2.6 1.3-5 3.3-6.4.4-.2.9-.1 1.1.3l.5.9c.2.3.1.8-.2 1-1.3 1-2.2 2.5-2.2 4.3 0 2.9 2.4 5.3 5.3 5.3s5.3-2.4 5.3-5.4c0-1.6-.8-3.2-2.2-4.2-.3-.2-.4-.6-.2-1l.6-.9c.2-.4.8-.5 1.1-.3zm-3.3 6.7V2.8c0-.4-.3-.8-.8-.8h-1c-.4 0-.7.3-.7.8v7.6c0 .4.3.8.8.8h1c.4-.1.7-.4.7-.8z" />
  </svg>
);

export default extendIcon(PowerOff);
